// import { User,UserManager, WebStorageStateStore } from "oidc-client-ts";

// export default new UserManager({
//   authority: import.meta.env.VITE_OIDC_AUTHORITY,
//   client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
//   client_secret: import.meta.env.VITE_OIDC_SECRET,
//   redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
//   scope:
//     "openid email profile groups offline_access audience:server:client_id:" +
//     import.meta.env.VITE_OIDC_AUDIENCE_CLIENT_ID,
   
//   // userStore: new WebStorageStateStore({ store: window.localStorage }),
// });

import { UserManager, WebStorageStateStore } from "oidc-client-ts";

// Initialize UserManager with configuration
const userManager = new UserManager({
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  client_secret: import.meta.env.VITE_OIDC_SECRET,
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  scope: "openid email profile groups offline_access audience:server:client_id:" + import.meta.env.VITE_OIDC_AUDIENCE_CLIENT_ID,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

// Set refresh token time and interval for token checking
const refreshTokenTime = 50; // Refresh token when less than 50 seconds remaining
const tokenCheckInterval = 500; // Check token expiration every 0.5 seconds

// Function to refresh access token
function refreshAccessToken() {
  userManager.signinSilent().then(() => {
    // console.log('Access token refreshed.');
  }).catch(error => {
    // console.error('Error refreshing access token:', error);
  });
}

// Function to check token expiry and refresh if necessary
function checkTokenExpiry() {
  // console.log("start check");
  userManager.getUser().then(user => {
    if (user && user.expires_at) {
      const now = Math.floor(Date.now() / 1000);
      const expiresIn = user.expires_at - now;
      if (expiresIn < refreshTokenTime) {
        refreshAccessToken();
      }
    }
    //  console.log('CurrentToken',user?.access_token)
     
  }).catch(error => {
    // console.error('Error checking token expiry:', error);
  });
}

// Periodically check token expiry and refresh if necessary
setInterval(checkTokenExpiry, tokenCheckInterval);

export default userManager;

